import { privacy } from "@redotech/schema-privacy";
import {
  Equal,
  objectEqual,
  optionalEqual,
  stringEqual,
} from "@redotech/util/equal";
import * as z from "zod";

export enum ProductAsVariantCreationStrategyKind {
  TitleRegex = "titleRegex",
  MetafieldValue = "metafieldValue",
  MergeVariantOptions = "mergeVariantOptions",
}

export const productAsVariantStrategyEqual: Equal<ProductAsVariantStrategy> =
  objectEqual<ProductAsVariantStrategy>({
    strategy: stringEqual,
    category: stringEqual,
    regex: optionalEqual(stringEqual),
    metafield: optionalEqual(
      objectEqual<{ namespace: string; key: string }>({
        namespace: stringEqual,
        key: stringEqual,
      }),
    ),
  });

export const ProductAsVariantTitleRegexStrategySchema = z.object({
  strategy: z
    .literal(ProductAsVariantCreationStrategyKind.TitleRegex)
    .meta({ privacy: privacy.nonPii }),
  regex: z.string().meta({ privacy: privacy.nonPii }),
  category: z.string().trim().meta({ privacy: privacy.nonPii }),
});
export type ProductAsVariantTitleRegexStrategy = z.infer<
  typeof ProductAsVariantTitleRegexStrategySchema
>;

export const ProductAsVariantMetafieldValueStrategySchema = z.object({
  strategy: z
    .literal(ProductAsVariantCreationStrategyKind.MetafieldValue)
    .meta({ privacy: privacy.nonPii }),
  metafield: z
    .object({
      namespace: z.string().trim().meta({ privacy: privacy.nonPii }),
      key: z.string().trim().meta({ privacy: privacy.nonPii }),
    })
    .meta({ privacy: privacy.structured }),
  regex: z.string().optional().meta({ privacy: privacy.nonPii }),
  category: z.string().trim().meta({ privacy: privacy.nonPii }),
});
export type ProductAsVariantMetafieldValueStrategy = z.infer<
  typeof ProductAsVariantMetafieldValueStrategySchema
>;

export const ProductAsVariantMergeVariantOptionsStrategySchema = z.object({
  strategy: z
    .literal(ProductAsVariantCreationStrategyKind.MergeVariantOptions)
    .meta({ privacy: privacy.nonPii }),
  category: z.string().trim().meta({ privacy: privacy.nonPii }),
});
export type ProductAsVariantMergeVariantOptionsStrategy = z.infer<
  typeof ProductAsVariantMergeVariantOptionsStrategySchema
>;

export const ProductAsVariantStrategySchema = z.discriminatedUnion("strategy", [
  ProductAsVariantTitleRegexStrategySchema,
  ProductAsVariantMetafieldValueStrategySchema,
  ProductAsVariantMergeVariantOptionsStrategySchema,
]);

export type ProductAsVariantStrategy = z.infer<
  typeof ProductAsVariantStrategySchema
>;
